<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard',
                    },
                    {
                      title: 'Assigned Trainings to Program officers',
                      url: '/#/dashboard/Admin/adminDashboard',
                      active: true
                    }
                  ]"
              ></vs-breadcrumb>
              <div class="frm-title">
                <div class="heading mt-3">
                  <h3
                    class="text-secondary"
                    style="font-size:20px;margin-bottom:0px"
                  >Assigned Trainings To Program Officers</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <template v-if="programOfficers !=''">
              <div
                class="col-sm-4 margin_bottom_admin"
                v-for="(officer,index) in programOfficers"
                :key="index"
              >
                <b-card v-if="officer.programofficer" class="h-100">
                  <b-card-text>
                    <router-link
                      v-if="officer.programofficer"
                      :to="{ path: '/dashboard/Admin/assignedTrainingsToAdvisor', query: { officerId:officer.programofficer.id }}"
                    >
                      <h5 class="text-primary">{{officer.title}}</h5>
                    </router-link>Assigned to :
                    <b v-if="officer.programofficer">{{officer.programofficer.name}}</b>
                    <div v-else>
                      <h5 class="text-primary">{{officer.title}}</h5>
                    </div>
                  </b-card-text>
                </b-card>
                <b-card v-else>
                  <b-card-text>
                    <h5 class="text-primary">{{officer.title}}</h5>Assigned to :
                    <b>Un Assigned</b>
                  </b-card-text>
                </b-card>
              </div>
            </template>
            <template v-else>
              <div class="col-sm-4 margin_bottom_admin">
                <b-card>
                  <b-card-text>
                    <h5 class="text-primary">No record found</h5>

                    <b>Un Assigned</b>
                  </b-card-text>
                </b-card>
              </div>
            </template>
          </div>

          <div class="frm-title">
            <div class="heading mt-3">
              <h3
                class="text-secondary"
                style="font-size:20px;margin-bottom:0px"
              >Agenda (Current Trainings)</h3>
            </div>
          </div>

          <div class="row">
            <!-- Agenda 1 -->
            <div class="col-sm-4" v-if="agendasArray.length">
              <h6>Day(s)</h6>
              <div>
                <vs-tabs>
                  <!-- Tab Day 1 -->
                  <vs-tab v-for="(day,index) in newArr" :key="index" :label="'Day '+(day.day)">
                    <div v-for="(agenda,i) in day.data" :key="i" class="con-tab-ejemplo">
                      <div class="card latest-update-card">
                        <div class="card-block">
                          <div class="scroll-widget">
                            <div class="latest-update-box">
                              <div class="row m-t-25 p-b-30">
                                <div class="col-auto text-right update-meta p-r-0">
                                  <i class="material-icons text-primary update-icon">donut_large</i>
                                </div>
                                <div class="col p-l-5">
                                  <a href="#">
                                    <h6>{{agenda.session}}:</h6>
                                  </a>
                                  <!-- <p class="text-muted m-b-0">
                                  <b>Monday</b> 12/6/2019
                                  </p>-->
                                  <p class="text-muted m-b-0">
                                    <b>Time</b>
                                    {{agenda.fromtime}} to {{agenda.totime}}
                                  </p>
                                  <p class="text-muted m-b-0">
                                    <b>Training By</b>
                                    {{agenda.user.name}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>
            <div class="col-sm-4" v-if="agendasArraySecond.length">
              <h6>Day(s)</h6>
              <div>
                <vs-tabs>
                  <!-- Tab Day 1 -->
                  <vs-tab
                    v-for="(day,index) in newArrSecond"
                    :key="index"
                    :label="'Day '+(day.day)"
                  >
                    <div v-for="(agenda,i) in day.data" :key="i" class="con-tab-ejemplo">
                      <div class="card latest-update-card">
                        <div class="card-block">
                          <div class="scroll-widget">
                            <div class="latest-update-box">
                              <div class="row m-t-25 p-b-30">
                                <div class="col-auto text-right update-meta p-r-0">
                                  <i class="material-icons text-primary update-icon">donut_large</i>
                                </div>
                                <div class="col p-l-5">
                                  <a href="#">
                                    <h6>{{agenda.session}}:</h6>
                                  </a>
                                  <!-- <p class="text-muted m-b-0">
                                  <b>Monday</b> 12/6/2019
                                  </p>-->
                                  <p class="text-muted m-b-0">
                                    <b>Time</b>
                                    {{agenda.fromtime}} to {{agenda.totime}}
                                  </p>
                                  <p class="text-muted m-b-0">
                                    <b>Training By</b>
                                    {{agenda.user.name}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>
            <div class="col-sm-4" v-if="agendasArrayThird.length">
              <h6>Day(s)</h6>
              <div>
                <vs-tabs>
                  <!-- Tab Day 1 -->
                  <vs-tab v-for="(day,index) in newArrThird" :key="index" :label="'Day '+(day.day)">
                    <div v-for="(agenda,i) in day.data" :key="i" class="con-tab-ejemplo">
                      <div class="card latest-update-card">
                        <div class="card-block">
                          <div class="scroll-widget">
                            <div class="latest-update-box">
                              <div class="row m-t-25 p-b-30">
                                <div class="col-auto text-right update-meta p-r-0">
                                  <i class="material-icons text-primary update-icon">donut_large</i>
                                </div>
                                <div class="col p-l-5">
                                  <a href="#">
                                    <h6>{{agenda.session}}:</h6>
                                  </a>
                                  <!-- <p class="text-muted m-b-0">
                                  <b>Monday</b> 12/6/2019
                                  </p>-->
                                  <p class="text-muted m-b-0">
                                    <b>Time</b>
                                    {{agenda.fromtime}} to {{agenda.totime}}
                                  </p>
                                  <p class="text-muted m-b-0">
                                    <b>Training By</b>
                                    {{agenda.user.name}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

export default {
  data: () => ({
    trainingId: "",
    advisorIDs: [],
    trarr: [],
    tranngOfficerIDIndex: "",
    allProgramOfficerIds: [],
    programOfficers: [],
    officersIds: [],
    sendOfficerIDs: [],
    alltraining: [],
    advisorArray: [],
    agendasArray: [],
    agendasArraySecond: [],
    agendasArrayThird: [],
    newArr: [],
    newArrSecond: [],
    newArrThird: [],
    isActve1: 1,

    isSidebar: false,
    colorx: "warning"
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  created() {
    this.trainingId = this.$route.query.training;
    this.allProgramOfficerTrainingsF();
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    allProgramOfficerTrainingsF: function allProgramOfficerTrainingsF() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/admin/advisor/get-officers/show/" +
            this.trainingId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.programOfficers = response.data;
        });
    }
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length;

    //Get three latest agendas
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/get/all/traning/agenda",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (
          response.data &&
          response.data != "no data to load" &&
          response.data.agendaone != undefined &&
          response.data.agendaone.length > 0
        ) {
          this.agendasArray = response.data.agendaone;
          this.agendasArray.forEach(val => {
            if (this.newArr.some(person => person.day === val.days)) {
              this.dayIndex = this.newArr.map(e => e.day).indexOf(val.days);
              this.newArr[this.dayIndex].data.push(val);
            } else {
              this.newArr.push({
                day: val.days,
                data: [val]
              });
            }
          });
        }
        if (
          response.data &&
          response.data != "no data to load" &&
          response.data.agendatwo != undefined &&
          response.data.agendatwo.length > 0
        ) {
          this.agendasArraySecond = response.data.agendatwo;
          this.agendasArraySecond.forEach(val => {
            if (this.newArrSecond.some(person => person.day === val.days)) {
              this.dayIndex = this.newArrSecond
                .map(e => e.day)
                .indexOf(val.days);
              this.newArrSecond[this.dayIndex].data.push(val);
            } else {
              this.newArrSecond.push({
                day: val.days,
                data: [val]
              });
            }
          });
        }
        if (
          response.data &&
          response.data != "no data to load" &&
          response.data.agendathree != undefined &&
          response.data.agendathree.length > 0
        ) {
          this.agendasArrayThird = response.data.agendathree;
          this.agendasArrayThird.forEach(val => {
            if (this.newArrThird.some(person => person.day === val.days)) {
              this.dayIndex = this.newArrThird
                .map(e => e.day)
                .indexOf(val.days);
              this.newArrThird[this.dayIndex].data.push(val);
            } else {
              this.newArrThird.push({
                day: val.days,
                data: [val]
              });
            }
          });
        }
      });
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.active {
  background: #dff0d8 !important;
  /* color:#fff !important; */
}
.active.training-title-cards {
  color: #fff !important;
}
ul.date-ul {
  display: inline-flex;
}
.date-ul li.start-date {
  padding-right: 35px;
}
.cards-row {
  margin-top: 10px !important;
}
.card-col {
  padding: 5px !important;
}
.main-card {
  color: #6c757d;
  border: 1px dotted #07a7e14f;
}
.main-card:hover {
  border: 1px solid #07a7e14f;
}
.training-title {
  /* font-size: 15px; */
  font-weight: 500;
  /* color: #212529 !important; */
}
.training-title-cards {
  font-size: 15px;
  font-weight: 500;
  /* color: #212529; */
}
.con-vs-card.withHover:hover img {
  -webkit-transform: scale(1);
  transform: scale(1);
}
.cardheader {
  display: inline-flex;
}

@media (max-width: 768px) {
  /* ul.date-ul {
    margin-top: -30px !important;
    display: block;
    margin-bottom: 25px;
  }
  .date-ul li {
    padding: 2px;
  }
  .cardheader {
    display: block;
  } */
  .card-col {
    width: 100% !important;
  }
  ul.date-ul {
    margin-top: 5px;
  }
  .date-ul li.start-date {
    padding-right: 26px;
  }
  .training-title {
    font-size: 14px;
  }
}
@media (max-width: 991.98px) {
  /* ul.date-ul {
    margin-top: -16px;
    display: block;
  } */
  .date-ul li.start-date {
    padding-right: 26px;
  }
  .card-col {
    width: 100% !important;
  }
  ul.date-ul {
    margin-top: 5px;
  }
}
.p-0 {
  padding: 0px;
}
.p-t-0 {
  padding-top: 0px;
}
.p-b-0 {
  padding-bottom: 0px;
}
.p-l-0 {
  padding-left: 0px;
}
.p-r-0 {
  padding-right: 0px;
}
.m-0 {
  margin: 0px;
}
.m-t-0 {
  margin-top: 0px;
}
.m-b-0 {
  margin-bottom: 0px;
}
.m-l-0 {
  margin-left: 0px;
}
.m-r-0 {
  margin-right: 0px;
}
.p-5 {
  padding: 5px;
}
.p-t-5 {
  padding-top: 5px;
}
.p-b-5 {
  padding-bottom: 5px;
}
.p-l-5 {
  padding-left: 5px;
}
.p-r-5 {
  padding-right: 5px;
}
.m-5 {
  margin: 5px;
}
.m-t-5 {
  margin-top: 5px;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-l-5 {
  margin-left: 5px;
}
.m-r-5 {
  margin-right: 5px;
}
.p-10 {
  padding: 10px;
}
.p-t-10 {
  padding-top: 10px;
}
.p-b-10 {
  padding-bottom: 10px;
}
.p-l-10 {
  padding-left: 10px;
}
.p-r-10 {
  padding-right: 10px;
}
.m-10 {
  margin: 10px;
}
.m-t-10 {
  margin-top: 10px;
}
.m-b-10 {
  margin-bottom: 10px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-r-10 {
  margin-right: 10px;
}
.p-15 {
  padding: 15px;
}
.p-t-15 {
  padding-top: 15px;
}
.p-b-15 {
  padding-bottom: 15px;
}
.p-l-15 {
  padding-left: 15px;
}
.p-r-15 {
  padding-right: 15px;
}
.m-15 {
  margin: 15px;
}
.m-t-15 {
  margin-top: 15px;
}
.m-b-15 {
  margin-bottom: 15px;
}
.m-l-15 {
  margin-left: 15px;
}
.m-r-15 {
  margin-right: 15px;
}
.p-20 {
  padding: 20px;
}
.p-t-20 {
  padding-top: 20px;
}
.p-b-20 {
  padding-bottom: 20px;
}
.p-l-20 {
  padding-left: 20px;
}
.p-r-20 {
  padding-right: 20px;
}
.m-20 {
  margin: 20px;
}
.m-t-20 {
  margin-top: 20px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.m-l-20 {
  margin-left: 20px;
}
.m-r-20 {
  margin-right: 20px;
}
.p-25 {
  padding: 25px;
}
.p-t-25 {
  padding-top: 25px;
}
.p-b-25 {
  padding-bottom: 25px;
}
.p-l-25 {
  padding-left: 25px;
}
.p-r-25 {
  padding-right: 25px;
}
.m-25 {
  margin: 25px;
}
.m-t-25 {
  margin-top: 25px;
}
.m-b-25 {
  margin-bottom: 25px;
}
.m-l-25 {
  margin-left: 25px;
}
.m-r-25 {
  margin-right: 25px;
}
.p-30 {
  padding: 30px;
}
.p-t-30 {
  padding-top: 30px;
}
.p-b-30 {
  padding-bottom: 30px;
}
.p-l-30 {
  padding-left: 30px;
}
.p-r-30 {
  padding-right: 30px;
}
.m-30 {
  margin: 30px;
}
.m-t-30 {
  margin-top: 30px;
}
.m-b-30 {
  margin-bottom: 30px;
}
.m-l-30 {
  margin-left: 30px;
}
.m-r-30 {
  margin-right: 30px;
}
.p-35 {
  padding: 35px;
}
.p-t-35 {
  padding-top: 35px;
}
.p-b-35 {
  padding-bottom: 35px;
}
.p-l-35 {
  padding-left: 35px;
}
.p-r-35 {
  padding-right: 35px;
}
.m-35 {
  margin: 35px;
}
.m-t-35 {
  margin-top: 35px;
}
.m-b-35 {
  margin-bottom: 35px;
}
.m-l-35 {
  margin-left: 35px;
}
.m-r-35 {
  margin-right: 35px;
}
.p-40 {
  padding: 40px;
}
.p-t-40 {
  padding-top: 40px;
}
.p-b-40 {
  padding-bottom: 40px;
}
.p-l-40 {
  padding-left: 40px;
}
.p-r-40 {
  padding-right: 40px;
}
.m-40 {
  margin: 40px;
}
.m-t-40 {
  margin-top: 40px;
}
.m-b-40 {
  margin-bottom: 40px;
}
.m-l-40 {
  margin-left: 40px;
}
.m-r-40 {
  margin-right: 40px;
}
.p-45 {
  padding: 45px;
}
.p-t-45 {
  padding-top: 45px;
}
.p-b-45 {
  padding-bottom: 45px;
}
.p-l-45 {
  padding-left: 45px;
}
.p-r-45 {
  padding-right: 45px;
}
.m-45 {
  margin: 45px;
}
.m-t-45 {
  margin-top: 45px;
}
.m-b-45 {
  margin-bottom: 45px;
}
.m-l-45 {
  margin-left: 45px;
}
.m-r-45 {
  margin-right: 45px;
}
.p-50 {
  padding: 50px;
}
.p-t-50 {
  padding-top: 50px;
}
.p-b-50 {
  padding-bottom: 50px;
}
.p-l-50 {
  padding-left: 50px;
}
.p-r-50 {
  padding-right: 50px;
}
.m-50 {
  margin: 50px;
}
.m-t-50 {
  margin-top: 50px;
}
.m-b-50 {
  margin-bottom: 50px;
}
.m-l-50 {
  margin-left: 50px;
}
.m-r-50 {
  margin-right: 50px;
}
.v-b {
  vertical-align: bottom;
}

.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}
.latest-update-card .card-block {
  padding-top: 0;
}
.latest-update-card .card-block .latest-update-box {
  position: relative;
}
.latest-update-card .card-block .latest-update-box:after {
  content: "";
  position: absolute;
  background: #ebebeb;
  height: 100%;
  width: 3px;
  top: 0;
  left: 19px;
  z-index: 1;
}
.latest-update-card .card-block .latest-update-box .update-meta {
  z-index: 2;
}
.latest-update-card .card-block .latest-update-box .update-meta .update-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  padding: 7px 8px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: #fff;
}
.latest-update-card .card-block .update-icon.bg-c-red {
  -webkit-box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
  box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
}
.latest-update-card .card-block .update-icon.bg-c-blue {
  -webkit-box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
  box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
}
.latest-update-card .card-block .update-icon.bg-c-green {
  -webkit-box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
  box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
}
.latest-update-card .card-block .update-icon.bg-c-yellow {
  -webkit-box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
  box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
}
.latest-update-card .card-block .update-icon.ring {
  border-width: 3px;
  width: 15px;
  height: 15px;
  padding: 0;
  display: block;
  margin-left: 13px;
  background: #fff;
}
.latest-update-card .card-block .latest-update-box .update-meta i.update-icon {
  margin-left: 4px;
  margin-right: 19px;
}
.latest-update-card .card-block .update-icon {
  padding: 0;
  width: 40px;
  height: 40px;
}
.bg-c-lite-blue {
  background: -webkit-gradient(linear-gradient(to right, #06a6e0, #00d2d6));
  background: linear-gradient(to right, #06a6e0, #00d2d6);
}
.bg-c-lite-purple {
  background: -webkit-gradient(linear-gradient(to right, #955cf9, #96a5f9));
  background: linear-gradient(to right, #955cf9, #96a5f9);
}
.bg-c-lite-pink {
  background: -webkit-gradient(linear-gradient(to right, #fe5d70, #fe909d));
  background: linear-gradient(to right, #fe5d70, #fe909d);
}

@media only screen and (max-width: 575px) {
  .latest-update-card .card-block .latest-update-box:after {
    display: none;
  }
  .latest-update-card .card-block .latest-update-box .update-meta {
    z-index: 2;
    min-width: 100%;
    text-align: left !important;
    margin-bottom: 15px;
    border-top: 1px solid #f1f1f1;
    padding-top: 15px;
  }
}
</style>

